import { motion, useReducedMotion } from "framer-motion";
import { PawPrint } from "lucide-react";

// Consistent internal-page header banner. Transform-only entrance (no opacity
// gate) so text stays visible regardless of animation state.
export default function PageHero({ eyebrow, title, sub, children }) {
  const reduce = useReducedMotion();
  const rise = (delay) =>
    reduce ? {} : { initial: { y: 14 }, animate: { y: 0 }, transition: { duration: 0.55, delay, ease: [0.22, 1, 0.36, 1] } };

  return (
    <section className="relative overflow-hidden bg-forest">
      <div className="grain pointer-events-none absolute inset-0 opacity-[0.06]" aria-hidden="true" />
      <div className="container-x relative py-14 sm:py-16">
        <motion.span {...rise(0)} className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-gold">
          <PawPrint className="h-3.5 w-3.5" strokeWidth={2.4} /> {eyebrow}
        </motion.span>
        <motion.h1 {...rise(0.06)} className="mt-3 max-w-3xl font-heading text-4xl font-extrabold tracking-tight text-cream sm:text-5xl">
          {title}
        </motion.h1>
        {sub && (
          <motion.p {...rise(0.12)} className="mt-4 max-w-2xl text-base leading-relaxed text-cream/75">
            {sub}
          </motion.p>
        )}
        {children && <div className="mt-7">{children}</div>}
      </div>
    </section>
  );
}
